import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import { ConfigurationsContainer } from '../../../containers/ConfigurationsContainer';
import { useFetchStripeSettings } from '../hooks/useFetchStripeSettings';
import type {
  StripeConfigurationControl,
  StripeConfigurationFormValues,
} from '../StripeConfigurationFormSchema';
import { CustomerConfigurationSection } from './components/CustomersConfigurationSection';
import { InvoicesConfigurationSection } from './components/InvoicesConfigurationSection';
import { KeyConfigurationSection } from './components/KeyConfigurationSection';
import { PaymentRefConfigurationSection } from './components/PaymentRefConfigurationSection';

type StripeConfigurationFormProps = {
  control: StripeConfigurationControl;
};

export const StripeConfigurationForm: FC<StripeConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchStripeSettings();
  const { reset } = useFormContext<StripeConfigurationFormValues>();

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <FormContainer>
      <Typography variant="h5">Configurations</Typography>
      <ConfigurationsContainer>
        <KeyConfigurationSection control={control} defaultValues={configuration} />
        <CustomerConfigurationSection control={control} defaultValues={configuration} />
        <InvoicesConfigurationSection control={control} defaultValues={configuration} />
        <PaymentRefConfigurationSection control={control} defaultValues={configuration} />
      </ConfigurationsContainer>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
